import React, { useState } from 'react';
import Select from 'react-select';
import './Formulario.css';
import { Form, Link } from 'react-router-dom';


  const formatCpf = (value) => {
    
    value = value.replace(/\D/g,'');

    if(value.length > 11) value = value.slice(0, 11);

    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return value;
  }

  const formaNum = (value) =>{
    value = value.replace(/\D/g,'');
    return value;
  }

function Formulario() {
  const [busca_nome, setBuscaNome] = useState("");
  const [busca_email, setBuscaEmail] = useState("");
  const [busca_rua, setBuscaRua] = useState("");
  const [busca_bairro, setBuscaBairro] = useState("");
  const [busca_profissao, setBuscaProfissao] = useState("");
  const [busca_escolaridade, setBuscaEscolaridade] = useState("");
  const [busca_planeta, setBuscaPlaneta] = useState("");
  const [busca_tel, setBuscaTel] = useState("");
  const [busca_cep, setBuscaCep] = useState("");
  const [busca_ncasa, setBuscaNcasa] = useState("");
  const [busca_cpf, setBuscaCpf] = useState("");
  const [busca_idade, setBuscaIdade] = useState("");
  const [check_saude, setCheckSaude] = useState(false);
  const handleOnChangeCheck1 = () => {setCheckSaude(!check_saude)};
  const [check_termos, setCheckTermos] = useState(false);
  const handleOnChangeCheck2 = () => {setCheckTermos(!check_termos)};
  const [error, setError] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault();
    if(busca_nome==""){
      setError("Preencha seu nome")
      return;
    }
    if(!busca_email.includes("@")){
      setError("E-mail inválido");
      return;
    }
    if(busca_profissao==""){
      setError("Escolha uma profissão")
      return;
    }
    if(busca_escolaridade==""){
      setError("Preencha sua escolaridade")
      return;
    }
    if(busca_planeta==""){
      setError("Escolha seu destino")
      return;
    }
    if (!busca_tel.match(/^\d{10,11}$/)) {
      setError("Telefone inválido");
      return;
    }
    if(busca_cep==""){
      setError("Digite um CEP")
      return;
    }
    if(busca_ncasa==""){
      setError("Digite o Número da sua casa")
      return;
    }
    if (!/^\d{11}$/.test(busca_cpf.replace(/\D/g, ''))){
      setError("CPF inválido")
      return;
    }
    if(busca_idade==""){
      setError("Digite sua idade")
      return;
    }
    if(busca_idade<18){
      setError("Minta sua idade (só maiores de 18)")
      return;
    }
    if(busca_idade>100){
      setError("Digite uma idade factível, me ajuda a te ajudar!")
      return;
    }
    if(!check_saude){
      setError("Vai no SUS e depois volta")
      return;
    }
    if(!check_termos){
      setError("Aceite os termos antes de prosseguir")
      return;
    }
    
    setError("");
    alert(`Nome: ${busca_nome}, Email: ${busca_email}, Rua: ${busca_rua}, Bairro: ${busca_bairro}, N°Casa: ${busca_ncasa}, CEP: ${busca_cep}, Profissão: ${busca_profissao}, Esolaridade: ${busca_escolaridade}, Planeta Destino: ${busca_planeta}, Telefone: ${busca_tel}, CPF: ${busca_cpf}, Idade: ${busca_idade} `);
  }


  return (
    <div className="Form">
      <form onSubmit={handleSubmit}>
      <header className="header_form">
        <h1>Formulário Inscrição Astroproject</h1>
      </header>

      <div className="corpo_form">
        <h1>Dados Gerais:</h1>
        <div className="div_pr">
          <div>
            <label>Nome:</label>
            <input
              type="text"
              placeholder="Digite seu nome: "
              className="form_txt"
              value={busca_nome}
              onChange={(e) => setBuscaNome(e.target.value)}
            />
          </div>
          <div>
            <label>E-mail:</label>
            <input
              type="email"
              placeholder="Digite seu e-mail"
              className="form_txt"
              value={busca_email}
              onChange={(e) => setBuscaEmail(e.target.value)}
            />
          </div>
          <div>
            <label>Rua:</label>
            <input
              type="text"
              placeholder="Digite sua rua"
              className="form_txt"
              value={busca_rua}
              onChange={(e) => setBuscaRua(e.target.value)}
            />
          </div>
          <div>
            <label>Bairro:</label>
            <input
              type="text"
              placeholder="Digite seu bairro"
              className="form_txt"
              value={busca_bairro}
              onChange={(e) => setBuscaBairro(e.target.value)}
            />
          </div>
        </div>

        <h1>Dados Pessoais:</h1>
        <div className="section_div">
          <div className="div_opc">
            <p>Selecione sua profissão:</p>
            <select
              name="Profissão"
              value={busca_profissao}
              onChange={(e) => setBuscaProfissao(e.target.value)}
              className="select"
            >
              <option value="" disabled>
                Escolha uma opção
              </option>
              <option>Flanelinha Espacial</option>
              <option>Desenvolvedor de erros</option>
              <option>Analista de opiniões</option>
            </select>
          </div>

          <div className="div_opc">
            <p>Selecione sua escolaridade:</p>
            <select
              name="Escolaridade"
              value={busca_escolaridade}
              onChange={(e) => setBuscaEscolaridade(e.target.value)}
              className="select"
            >
              <option value="" disabled>
                Escolha uma opção
              </option>
              <option>Ensino fundamental completo</option>
              <option>Ensino fundamental incompleto</option>
              <option>Ensino médio completo</option>
              <option>Ensino médio incompleto</option>
              <option>Ensino superior completo</option>
              <option>Ensino superior incompleto</option>
            </select>
          </div>

          <div className="div_opc">
            <p>Selecione seu destino:</p>
            <select
              name="Planeta"
              value={busca_planeta}
              onChange={(e) => setBuscaPlaneta(e.target.value)}
              className="select"
            >
              <option value="" disabled>
                Escolha uma opção
              </option>
              <option>Mercúrio</option>
              <option>Vênus</option>
              <option>Terra</option>
              <option>Marte</option>
              <option>Jupiter</option>
              <option>Saturno</option>
              <option>Urano</option>
              <option>Netuno</option>
            </select>
          </div>
        </div>

        <h1>Dados numéricos:</h1>
        <div className="div_numerica">
          <div className="fds">
            <label>Telefone:</label>
            <input
              type="tel"
              name="telefone"
              value={busca_tel}
              placeholder="Digite seu telefone:"
              className="abacate"
              onChange={(e) => setBuscaTel(formaNum(e.target.value))}
            />
          </div>
          <div className="fds">
            <label>CEP:</label>
            <input
              type="tel"
              name="CEP"
              value={busca_cep}
              placeholder="Digite seu CEP:"
              className="abacate"
              onChange={(e) => setBuscaCep(formaNum(e.target.value))}
            />
          </div>
          <div className="fds">
            <label>Numéro da casa:</label>
            <input
              type="tel"
              name="Numero da casa"
              value={busca_ncasa}
              placeholder="Digite o n° da casa:"
              className="abacate"
              onChange={(e) => setBuscaNcasa(formaNum(e.target.value))}
            />
          </div>
          <div className="fds">
            <label>CPF:</label>
            <input
              type="tel"
              name="CPF"
              value={busca_cpf}
              placeholder="Digite seu CPF:"
              className="abacate"
              onChange={(e) => setBuscaCpf(formatCpf(e.target.value))}
            />
          </div>
          <div className="fds">
            <label>Idade:</label>
            <input
              type="tel"
              name="Idade"
              value={busca_idade}
              placeholder="Digite sua Idade:"
              className="abacate"
              onChange={(e) => setBuscaIdade(formaNum(e.target.value))}
            />
          </div>
        </div>

        <h1>Outros:</h1>
        <div className="div_outros">
          <div>
          <nav className="label_check">
            <label>Estou em plena saúde</label>
            <label>Aceito os <Link to="/termos" className='botao_termos'>termos e condições</Link> </label>
          </nav>
          </div>
          <div className="check">
            <input
              type="checkbox"
              name="checkbox_saude"
              checked={check_saude}
              onChange={handleOnChangeCheck1}
            />
            <input
              type="checkbox"
              name="checkbox_termos"
              checked={check_termos}
              onChange={handleOnChangeCheck2}
            />
          </div>
        </div>
      </div>
      <div className='div_submit'>
        {error && <p style={{color:'red'}}>{error}</p>}
        <input type="submit" value="Enviar" className='botao_submit' />
      </div>
      </form>
    </div>
  );
}

export default Formulario;
